import script from "./EcommercePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EcommercePage.vue?vue&type=script&lang=ts&setup=true"

import "./EcommercePage.vue?vue&type=style&index=0&id=1502a7c4&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1502a7c4"]])

export default __exports__